// import { useEffect } from 'react'
import useSWR from 'swr'
import { CustomerAPI, CustomerFetcher } from '../../apis/CustomerAPI'
import MyAccountWrapper from '../../components/MyAccountWrapper'
import { useEffect } from 'react'
import { useRouter } from 'next/router'

function Dashboard() {
    const { data: customer, error } = useSWR(
        CustomerAPI.getCustomer,
        CustomerFetcher,
    )

    const router = useRouter()

    // useEffect(async () => {
    //     if(customer){
    //         console.log(customer)
    //         // console.log(await UserAPI.getUser(customer.id))
    //     }
    // })

    useEffect(() => {
        router.push('/my-account/orders')
    }, [])

    return (
        <MyAccountWrapper title={'Dashboard'} error={error}>
            {error ? 'Failed to Load' : customer ? <></> : 'Loading...'}
            <p>Choose from menus.</p>
        </MyAccountWrapper>
    )
}

export default Dashboard
